import React from 'react';
import { Row, Col } from '../../components/RowCol';
import { Question } from '../Game/Game';
import Spacer from '../../components/Spacer';
import TextEditor from '../../components/TextEditor';
import { EditFunction } from './GameEditor';
import Button from '../../components/Button';
import AddImageButton from '../../components/AddImageButton';
import LocalFileStorage from '../../LocalFileStorage';
import AddAudioButton from '../../components/AddAudioButton';
import LocalAudio from '../../components/LocalAudio';

type Props = {
	question: Question;
	edit: EditFunction;
	allowDailyDouble: boolean;
	localFileStorage: LocalFileStorage;
};
type State = {};

class QuestionEditor extends React.Component<Props, State> {
	render() {
		const { question, edit, allowDailyDouble, localFileStorage } = this.props;

		return (
			<Col>
				<Row>
					<TextEditor
						placeholder="Question"
						text={question.text}
						edit={text => {
							edit(
								['text'],
								'edit',
								text,
							);
						}}
						multiline
					/>
					<Spacer horizontal={5} />
					{allowDailyDouble && (
						<Col>
							<div style={{
								fontFamily: 'Korinna',
							}}>
								DD
							</div>
							<input
								type="checkbox"
								checked={!!question.dailyDouble}
								onChange={() => {
									if (question.dailyDouble) {
										edit(
											['dailyDouble'],
											'delete_field',
										);
									} else {
										edit(
											['dailyDouble'],
											'edit',
											true,
										);
									}
								}}
							/>
						</Col>
					)}
				</Row>
				<Spacer vertical={8} />
				<Row>
					<TextEditor
						placeholder="Answer"
						text={question.answer ?? ''}
						edit={answer => {
							if (answer.length > 0) {
								edit(
									['answer'],
									'edit',
									answer,
								);
							} else {
								edit(
									['answer'],
									'delete_field',
								);
							}
						}}
					/>
					<Spacer horizontal={12} />
					{(() => {
						if ('image' in question) {
							return (
								<Button
									small
									label="Delete Image"
									onClick={() => {
										edit(
											['image'],
											'delete_field',
										);
									}}
								/>
							);
						} else if ('audio' in question) {
							return (
								<Button
									small
									label="Delete Audio"
									onClick={() => {
										edit(
											['audio'],
											'delete_field',
										);
									}}
								/>
							);
						} else {
							return (
								<>
									<AddImageButton
										localFileStorage={localFileStorage}
										addImage={key => {
											edit(
												['image'],
												'edit',
												key,
											);
										}}
									/>
									<Spacer horizontal={12} />
									<AddAudioButton
										localFileStorage={localFileStorage}
										addAudio={key => {
											edit(
												['audio'],
												'edit',
												key,
											);
										}}
									/>
								</>
							);
						}
					})()}
				</Row>
				{'audio' in question && (
					<LocalAudio
						localFileStorage={localFileStorage}
						dbKey={question.audio}
						style={{
							height: '20px',
						}}
						controls
					/>
				)}
			</Col>
		);
	}
}

export default QuestionEditor;
